<template>
  <div>
    <v-list-item>
      <v-list-item-avatar color="#2f3860" style="align-self: normal">
        <img
          v-if="speaker.image"
          class="speaker-avatar-image"
          :src="speaker.image"
          alt="Image"
        />
        <v-icon v-else color="white" size="25">{{ mdiAccount }}</v-icon>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title>{{ speaker.name }}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <div
      v-if="speaker.bio"
      class="text-wrap px-3"
      style="text-align: justify; font-weight: 300"
    >
      {{ speaker.bio[lang] }}
    </div>
  </div>
</template>

<script>
import { mdiAccount } from "@mdi/js";

export default {
  data() {
    return {
      mdiAccount,
    };
  },
  props: ["speaker"],
  computed: {
    lang() {
      return this.$i18n.locale;
    },
  },
};
</script>

<style scoped>
.speaker-avatar-image {
  width: 100%;
  height: 100%;

  object-fit: cover;
}
</style>